module.exports = __webpack_public_path__ + "img/DCL image.d3f4fc80.png";